// Verrou de déconnexion partagé entre les onglets.
//
// Les jetons OIDC vivent dans sessionStorage (défaut d'oidc-client-ts), donc chaque onglet
// a sa propre copie et rien ne les synchronise. Sans verrou, dès que l'onglet initiateur
// signale la déconnexion, les autres onglets voient `isAuthenticated` tomber à false et
// relancent aussitôt un signinRedirect/signinSilent. Le cookie SSO Keycloak est alors
// encore vivant (la navigation vers l'end_session_endpoint n'est pas terminée) : Keycloak
// réauthentifie en silence et ouvre une NOUVELLE session, que la déconnexion en cours ne
// terminera pas — son id_token_hint désigne l'ancienne. Résultat : le cookie SSO survit et
// toute reconnexion ultérieure est silencieuse.
//
// On utilise localStorage (et non un BroadcastChannel) car le verrou doit survivre à la
// navigation complète de l'onglet initiateur vers Keycloak et à son retour.
const CLE = "ravailLogout";

// Filet de sécurité : si l'onglet initiateur ne revient jamais de Keycloak (erreur, onglet
// fermé), le verrou ne doit pas bloquer indéfiniment la reconnexion des autres onglets.
const DUREE_MAX_MS = 60000;

export const CLE_DECONNEXION = CLE;

export const demarrerDeconnexion = () => localStorage.setItem(CLE, String(Date.now()));

export const terminerDeconnexion = () => localStorage.removeItem(CLE);

export const deconnexionEnCours = () => {
  const debut = Number(localStorage.getItem(CLE));
  if (!debut) return false;
  if (Date.now() - debut > DUREE_MAX_MS) {
    localStorage.removeItem(CLE);
    return false;
  }
  return true;
};
